export default "__VITE_ASSET__CHl3rqIQ__"